module.exports = __webpack_public_path__ + "img/icon_search.a882e91e.svg";